import React from 'react';
import { TouchableOpacity, ViewStyle, Text, TextStyle, GestureResponderEvent } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

type Props = {
  title: string;
  onPress: (event: GestureResponderEvent) => void;
  disabled?: boolean;
  accessibilityId?: string;
  // Style pass-through to avoid altering caller styles/layout
  cellStyle: ViewStyle;
  cellDisabledStyle?: ViewStyle;
  titleStyle: TextStyle;
};

export const ChevronListItem: React.FC<Props> = ({
  title,
  onPress,
  disabled,
  accessibilityId,
  cellStyle,
  cellDisabledStyle,
  titleStyle,
}) => {
  return (
    <TouchableOpacity
      style={[cellStyle, disabled && cellDisabledStyle]}
      onPress={onPress}
      accessibilityLabel={accessibilityId ? `ProfileCell_${accessibilityId}` : undefined}
      testID={accessibilityId ? `ProfileCell_${accessibilityId}` : undefined}
      disabled={disabled}
    >
      <Text style={titleStyle}>{title}</Text>
      <RESIDENTS_SVG_COMPONENTS.CHEVRON_RIGHT width={14} height={14} />
    </TouchableOpacity>
  );
};

export default ChevronListItem;


